import React from 'react';
import PropTypes from 'prop-types';
import { StyledPopupBox, StyledBox, StyledcloseIcon } from './index.styled';

const Popup = (props) => (
	<StyledPopupBox>
		<StyledBox>
			<StyledcloseIcon className="close-icon" onClick={props.handleClose}>
				x
			</StyledcloseIcon>
			{props.content}
		</StyledBox>
	</StyledPopupBox>
);

Popup.propTypes = {
	handleClose: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
};

export default Popup;
